import { CLI_V2, PROP } from "../../Data/typeDirs"
import { DateToFormattedString, genId } from "../../utils"


export class Property{
  constructor(data = {}){
    this._id = data._id || genId()
    this.name = data.name || ''
    this.created = data.created || Date.now()
    this.modified = data.modified || this.created
    this._createdBy = data._createdBy
    this._modifiedBy = data.modifiedBy
    this.dirName = Property.getNewDirName(this.name, this.created)
    this.address = data.address || {streetAddress:'', city:'', state:''}
    this.info = data.info || ''
    this.photo = data.photo || null
    this._clients_v2 = data._clients_v2 || data.clients_v2 || null
    this.type = Property.getTypeDir()
  }

  static getNewDirName(name, created){ return `${name}-${DateToFormattedString(new Date(created), true)}` }
  static getTypeDir(){ return PROP }
  static getIndices() { return '_id,name' }

  getContents(){
    let {name, address, phoneNumber, info, logo, _clients_v2} = this
    return [{name, _clients_v2, address, phoneNumber, info, logo, type:'propertyData', schema:'propertyDataSchema'}]
  }
  
  getPhotoContents(){
    return [{photo:this.photo, type:'propertyPhoto', schema: 'propertyPhotoSchema'}]
  }

  getSchemas(){
    return [{name:'propertyDataSchema', _id:genId(), content: [
      {
        name: 'root',
        type: 'Container',
        children: [
          {
            name:'nameContainer',
            type: 'Container',
            displaySettings: {as: "Row"},
            children: [ 
              {
                name: 'name',
                type: 'text',
                placeholder: 'Property Name'
              },
              {
                name: `_${CLI_V2}`,
                type: 'dropdown',
                source: CLI_V2,
                label: "Client"
              }
            ]
          }, {
            name: 'infoContainer',
            type: 'Container',
            displaySettings: {as: 'Row'},
            children: [ 
              {
                name: 'address',
                type: 'address',
                placeholder: 'Address'
              },{
                name: 'phoneNumber',
                type: 'text',
                placeholder: 'Phone Number'
              },{
                name: 'info',
                type: 'text',
                displaySettings: {as: 'textarea' },
                placeholder: 'Extra info'
              }
            ]
          }
        ]
      }
    ]}, { name: 'propertyPhotoSchema', _id: genId(), content:[
      { 
        name: 'root',
        type: 'Container',
        children: [
          {
            name: 'photoContainer',
            type: 'Container',
            displaySettings: {as: 'Row'},
            children: [
              {
                name: 'photo',
                placeholder: 'photo',
                type: 'image',
                options: {thumbnailSize: 'lg'}
              }
            ]
          }
        ]
      }
    ]

    }]
  }
}